import { workshop } from '@/interfaces/workshop'
import { BaseRequest } from '@/network/requests/BaseRequest'

export const workshopRequest = BaseRequest.build<workshop>('workshop')
